import { Update } from '@ngrx/entity';
import { createAction, props } from '@ngrx/store';
import { IInvoiceCycle } from '../../../../contract-management/IInvoiceCycle';
import { SelectItem } from '../../../../shared';
import { Invoice } from './invoice.model';

export const loadInvoices = createAction(
    '[Invoice/API] Load Invoices',
    props<{ invoices: Invoice[] }>()
);

export const addInvoice = createAction(
    '[Invoice/API] Add Invoice',
    props<{ invoice: Invoice }>()
);

export const upsertInvoice = createAction(
    '[Invoice/API] Upsert Invoice',
    props<{ invoice: Invoice }>()
);

export const addInvoices = createAction(
    '[Invoice/API] Add Invoices',
    props<{ invoices: Invoice[] }>()
);

export const upsertInvoices = createAction(
    '[Invoice/API] Upsert Invoices',
    props<{ invoices: Invoice[] }>()
);

export const updateInvoice = createAction(
    '[Invoice/API] Update Invoice',
    props<{ invoice: Update<Invoice> }>()
);

export const updateInvoices = createAction(
    '[Invoice/API] Update Invoices',
    props<{ invoices: Update<Invoice>[] }>()
);

export const deleteInvoice = createAction(
    '[Invoice/API] Delete Invoice',
    props<{ id: string }>()
);

export const deleteInvoices = createAction(
    '[Invoice/API] Delete Invoices',
    props<{ ids: string[] }>()
);

export const clearInvoices = createAction('[Invoice/API] Clear Invoices');

export const getInvoices = createAction('[Invoice/API] Get Invoices');

export const postInvoices = createAction(
    '[Invoice/API] Post Invoices',
    props<{
        startDate?: Date;
        endDate?: Date;
        contractList?: string[];
        showInactive?: boolean;
        showInvoicesOnly?: boolean;
    }>()
);

export const postUpdateInvoices = createAction(
    '[Invoice/API] Post Update Invoices',
    props<{
        startDate?: Date;
        endDate?: Date;
        contractList?: string[];
        showInactive?: boolean;
        showInvoicesOnly?: boolean;
        resetInvoiceSchedule?: boolean;
    }>()
);

export const putInvoices = createAction(
    '[Invoice/API] Put Invoices',
    props<{ startDate: Date; endDate: Date; invoices: Invoice[] }>()
);

export const getActiveContracts = createAction(
    '[Invoice/API] Get Active Contracts',
    props<{ startDate: Date; endDate: Date; showInactive: boolean }>()
);

export const loadActiveContracts = createAction(
    '[Invoice/API] Load Active Contracts',
    props<{ contracts: SelectItem[] }>()
);

export const putInvoiceCycle = createAction(
    '[Invoice/API] Put Invoice Cycle',
    props<{ item: IInvoiceCycle }>()
);
